import { LoginPage } from "./../login/login";
// import { RequestOptions, Http, Headers } from '@angular/http';
// import { ServiceProvider } from './../../providers/service/service';
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { IonicPage, NavController, AlertController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-view-header2",
  templateUrl: "view-header2.html",
})
export class ViewHeader2Page {
  plaza_name: any;
  no = "";
  label = "";
  name = "";
  shopper_id = "";
  budget: any;
  space: any;
  recentry: any;
  url: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public storage: Storage,
    // private services: ServiceProvider,
    // private http: Http,
    private alertCtrl: AlertController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("info").then((info) => {
      if (info.role == 1) {
        this.label = "PLAZA";
        this.plaza_name = info.team.plaza_id;
        if (this.plaza_name == 1) {
          this.no = "A";
        } else if (this.plaza_name == 2) {
          this.no = "B";
        } else if (this.plaza_name == 3) {
          this.no = "C";
        } else if (this.plaza_name == 4) {
          this.no = "D";
        } else if (this.plaza_name == 5) {
          this.no = "E";
        } else if (this.plaza_name == 6) {
          this.no = "F";
        }
      } else if (info.role == 2) {
        this.label = "MERCHANT";
        this.no = info.team.merchant_id;
      } else {
        this.label = "SHOPPER";
        this.name = info.name;
        this.shopper_id = info.team.shopper_id;
      }
    });

    // this.storage.get('token').then((token) => {

    //   this.storage.get('info').then((info) => {
    //       if (info.role==1) {
    //         this.url = this.services.URLPlazaStatBudgets;
    //       } else if (info.role==2) {
    //         this.url = this.services.URLMerchantStatBudgets;
    //       } else if (info.role==3) {
    //         this.url = this.services.URLShopperStatBudgets;
    //       }
    //       var link = this.url;
    //       var headers = new Headers();
    //       headers.append("Accept", 'application/json');
    //       headers.append("Authorization", "Bearer "+token);
    //       const requestOptions = new RequestOptions({ headers: headers });

    //       this.http.get( link, requestOptions ).map(res => res.json()).subscribe(data => {
    //           this.budget = this.services.currencyFormat(data.available);
    //           if (info.role==2) {
    //             this.recentry = data.recently_receive;
    //           }
    //       }, error => {
    //           // console.log(error);
    //           this.services.presentToastInternet();
    //       });

    //       if (info.role==1) {
    //           var link2 = this.services.URLPlazaSpace;

    //           this.http.get( link2, requestOptions ).map(res => res.json()).subscribe(data => {
    //               this.space = data;
    //           }, error => {
    //               // console.log(error);
    //               this.services.presentToastInternet();
    //           });
    //       }

    //     });

    // });
  }

  logout() {
    const confirm = this.alertCtrl.create({
      // title: 'Remove this shop?',
      message: "Are you sure you want to logout?",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            if (this.storage.clear()) {
              this.navCtrl.setRoot(LoginPage);
            }
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  back() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/view-header2/view-header2.ts